export const typeLoadingEnum = {
    PATIENT:'patient',
    GUARDIAN:'guardian',
    REFERRED_DOCTOR:'referred_doctor',
    REFERRED_CENTER:'referred_center',
}
